export enum EventStatus {
  Waiting = 101,
  Started = 102,
  Finished = 103,
  Cancelled = 200,
}